var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChevronDownBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.999 18.4883C14.3066 18.4795 14.5879 18.3652 14.8164 18.1191L21.4961 11.2812C21.6895 11.0879 21.7949 10.8418 21.7949 10.5518C21.7949 9.97168 21.3379 9.50586 20.7578 9.50586C20.4766 9.50586 20.2041 9.62012 20.002 9.82227L14.0078 15.9834L7.99609 9.82227C7.79395 9.62891 7.53027 9.50586 7.24023 9.50586C6.66016 9.50586 6.20312 9.97168 6.20312 10.5518C6.20312 10.8418 6.30859 11.0879 6.50195 11.2812L13.1904 18.1191C13.4277 18.3652 13.6914 18.4883 13.999 18.4883Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevronDownBlack);
export default __webpack_public_path__ + "static/media/ic_chevron_down_black.bacb555afa6e6e4276cfffdaf9b41262.svg";
export { ForwardRef as ReactComponent };